import React from "react";

/**
 * BusinessDayCell Component
 * Displays business day and business day instance
 * @param {Object} row - The row data object
 */
const BusinessDayCell = ({ row }) => {
  return (
    <span className="text-sm font-normal">
      {row.original.BusinessDay}
      <br />
      {row.original.BusinessDayInstance}
    </span>
  );
};

export default BusinessDayCell;
